function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import axios from 'axios';
import config from './config';
import state from '../store';
var domains = {
  global: window.feConfig.common.scApiBaseUrl + "misc/",
  core: window.feConfig.common.apiBaseUrl + "core/",
  udp: window.feConfig.common.apiBaseUrl + "udp/"
};
var Api = {
  name: 'Api'
};
var http = {};
var defaultOptions = {
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    source: config.source
  },
  validateStatus: function validateStatus(status) {
    return status < 400;
  }
};
var getConfig = function getConfig(options) {
  options = Object.assign(defaultOptions, options);
  return options;
};
var request = {
  resolve: function resolve(config) {
    // if (config.method === 'get') {
    //   // 给config.data赋值, 使Content-type起作用
    //   config.data = true
    // }
    config.headers.token = state.localStorage.getItem('token');
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    return config;
  },
  reject: function reject(error) {
    // eslint-disable-next-line
    return Promise.reject('req', error);
  }
};
var response = {
  resolve: function resolve(response) {
    if (response.status === 201) {
      response.data = response.data || {};
      typeof response.data === 'object' && (response.data.Location = response.headers.location);
    }
    return response.data;
  },
  reject: function reject(error) {
    var data = error.response && error.response.data ? error.response.data : _extends({}, error);
    return Promise.reject(data);
  }
};
var _loop = function _loop(key) {
  var baseURL = domains[key];
  var options = getConfig({
    baseURL: baseURL,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      source: config.source
    }
  });
  var apiKey = key + 'Api';
  http[apiKey] = axios.create(options);
  http[apiKey].interceptors.request.use(request.resolve, request.reject);
  http[apiKey].interceptors.response.use(response.resolve, response.reject);
  http[apiKey].originGet = http[apiKey].get;
  http[apiKey].get = function (url, data, config) {
    if (data === void 0) {
      data = {};
    }
    if (config === void 0) {
      config = {};
    }
    data = Object.prototype.hasOwnProperty.call(data, 'bar') ? data : Object.assign({
      params: data
    }, config || {});
    return http[apiKey].originGet(url, data);
  };
};
for (var key in domains) {
  _loop(key);
}
var envNow = 'dev';
var setConfig = function setConfig(env, source) {
  if (env === void 0) {
    env = 'dev';
  }
  if (source === void 0) {
    source = config.source;
  }
  envNow = env;
  if (state.isBrowser) {
    if (!window.envConfig) {
      window.envConfig = {};
    }
    window.envConfig.env = envNow; // 设置全局变量
  }

  for (var _key in domains) {
    var apiKey = _key + 'Api';
    var api = http[apiKey];
    if (api) {
      api.defaults.baseURL = domains[_key];
      api.defaults.headers.source = source;
    }
  }
};
Api.setConfig = function (options) {
  options = typeof options === 'string' ? {
    env: options,
    source: config.source
  } : options;
  domains = options.domain || config[options.env] || domains;
  setConfig(options.env, options.source);
};
Api.create = function (options) {
  options = Object.assign(defaultOptions, options);
  var api = axios.create(options);
  api.interceptors.request.use(request.resolve, request.reject);
  api.interceptors.response.use(response.resolve, response.reject);
  return api;
};
export { http, envNow, domains };
export default Api;